var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPillsIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1231_4383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1322 21.8324C17.821 20.1437 19.2893 18.6754 20.5674 17.3973V11.4416C20.5674 10.1222 19.3249 8.96484 17.9084 8.96484H16.8174C16.8174 8.35828 16.8174 7.56129 16.8174 6.97266H17.3968C18.3367 6.97266 19.1611 6.16453 19.1611 5.24326V1.84119C19.1611 0.97207 18.4066 0 17.3968 0H15.1093V5.21484H13.3515V0H11.1924V5.21484H9.43457V0H7.13412V5.21484H5.37631V0H3.23014C2.22033 0 1.46582 0.97207 1.46582 1.84119V5.24326C1.46582 6.16453 2.29023 6.97266 3.23014 6.97266H3.69238V8.96484H2.77715C1.40605 8.96484 0.000976562 10.0948 0.000976562 11.4416V27.4207C0.000976562 28.7224 1.37611 30 2.77715 30H16.3284L16.1322 29.8038C13.9346 27.6062 13.9346 24.0302 16.1322 21.8324ZM11.1924 20.3613V23.2982C11.1924 23.7836 10.7989 24.1771 10.3135 24.1771C9.82809 24.1771 9.43457 23.7836 9.43457 23.2982V20.3613H6.49768C6.01229 20.3613 5.61877 19.9678 5.61877 19.4824C5.61877 18.997 6.01229 18.6035 6.49768 18.6035H9.43457V15.6666C9.43457 15.1812 9.82809 14.7877 10.3135 14.7877C10.7989 14.7877 11.1924 15.1812 11.1924 15.6666V18.6035H14.1293C14.6147 18.6035 15.0082 18.997 15.0082 19.4824C15.0082 19.9678 14.6147 20.3613 14.1293 20.3613H11.1924Z",
    fill: "url(#paint0_linear_1231_4383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8648 17.6772L28.5618 17.3742C27.0452 15.8576 24.5839 15.8666 23.0765 17.374L20.9121 19.5385L26.7006 25.3269L28.8649 23.1627C30.3772 21.6504 30.3772 19.1896 28.8648 17.6772Z",
    fill: "url(#paint1_linear_1231_4383)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.375 23.0754C15.8626 24.5878 15.8626 27.0486 17.375 28.5609L17.678 28.864C19.1903 30.3763 21.6511 30.3763 23.1635 28.864L25.4574 26.57L19.6689 20.7815L17.375 23.0754Z",
    fill: "url(#paint2_linear_1231_4383)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1231_4383",
    x1: 0.288071,
    y1: 24,
    x2: 20.5674,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1231_4383",
    x1: 21.039,
    y1: 23.5096,
    x2: 29.9991,
    y2: 23.5096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1231_4383",
    x1: 16.3694,
    y1: 28.1549,
    x2: 25.4574,
    y2: 28.1549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2E854"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1231_4383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillsIc);
export default __webpack_public_path__ + "static/media/pills_ic.0aca9c9f89aee2ba223e7446142d97ef.svg";
export { ForwardRef as ReactComponent };